import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Input, message } from 'antd';
import { api } from '../lib/api';
import LegalFooter from '../components/LegalFooter';
import { apiBaseUrl } from '../lib/api';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const nextPath = location.state?.from?.pathname || '/dashboard/tasks';

  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (token && user?.status === 'active') {
      navigate('/dashboard/tasks', { replace: true });
    }
  }, [navigate]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await api.post('/api/auth/login', {
        username: values.username,
        password: values.password
      });

      if (response.data.role !== 'ADMIN') {
        message.error('当前账号没有管理后台权限');
        return;
      }
      
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data));
      message.success('登录成功');
      navigate(nextPath, { replace: true });
    } catch (error) {
      message.error('登录失败：' + (error.response?.data?.message || '网络错误'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '24px',
      background: 'radial-gradient(circle at top left, rgba(58, 123, 213, 0.22), transparent 30%), linear-gradient(160deg, #eef6ff 0%, #dcecff 48%, #cddff8 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        position: 'absolute',
        top: '-8%',
        right: '-4%',
        width: '420px',
        height: '420px',
        background: 'rgba(22, 119, 255, 0.16)',
        borderRadius: '50%',
        filter: 'blur(70px)'
      }} />
      <div style={{
        position: 'absolute',
        bottom: '-12%',
        left: '-8%',
        width: '340px',
        height: '340px',
        background: 'rgba(31, 42, 68, 0.12)',
        borderRadius: '50%',
        filter: 'blur(70px)'
      }} />
      
      <div style={{
        width: '100%',
        maxWidth: '430px',
        padding: '40px 36px',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '24px',
        boxShadow: '0 28px 80px rgba(31, 42, 68, 0.18)',
        border: '1px solid rgba(255, 255, 255, 0.65)',
        backdropFilter: 'blur(18px)',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ marginBottom: '32px' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '6px 12px',
            borderRadius: '999px',
            backgroundColor: '#e8f1ff',
            color: '#1d4ed8',
            fontSize: '12px',
            fontWeight: 600,
            letterSpacing: '0.04em',
            marginBottom: '18px'
          }}>
            BAIXIAOSHENG ADMIN
          </div>
          <h1 style={{
            fontSize: '30px',
            lineHeight: 1.2,
            marginBottom: '10px',
            color: '#1f2a44',
            fontWeight: 700
          }}>
            百晓生管理后台
          </h1>
          <div style={{
            fontSize: '14px',
            color: '#6b7280',
            lineHeight: 1.6
          }}>
            登录后可统一处理任务审核、用户管理、客服工单与支付状态。
          </div>
        </div>
        
        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            label="用户名"
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input 
              placeholder="请输入用户名"
              style={{
                height: '46px',
                border: '1px solid #d6e4ff',
                borderRadius: '12px',
                fontSize: '14px'
              }}
            />
          </Form.Item>

          <Form.Item
            label="密码"
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              placeholder="请输入密码"
              style={{
                height: '46px',
                border: '1px solid #d6e4ff',
                borderRadius: '12px',
                fontSize: '14px'
              }}
            />
          </Form.Item>

          <Form.Item style={{ marginTop: '32px' }}>
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                height: '48px',
                background: loading
                  ? '#9cc7ff'
                  : 'linear-gradient(135deg, #1677ff 0%, #2457d6 100%)',
                color: '#FFF',
                border: 'none',
                borderRadius: '14px',
                boxShadow: loading ? 'none' : '0 14px 28px rgba(22, 119, 255, 0.28)',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              {loading ? '登录中...' : '登录'}
            </button>
          </Form.Item>
        </Form>

        {apiBaseUrl.includes('localhost') && (
          <div style={{
            marginTop: 16,
            padding: '10px 12px',
            borderRadius: 10,
            background: '#f0f9ff',
            fontSize: 12,
            color: '#1e40af',
            lineHeight: 1.6,
          }}>
            本地开发默认管理员：<strong>admin</strong> / <strong>admin123</strong>
            （需先重启后端以初始化 H2 账号）
          </div>
        )}

        <LegalFooter compact />
        <div style={{ marginTop: 12, textAlign: 'center', fontSize: 11, color: '#9ca3af' }}>
          API：{apiBaseUrl}
        </div>
      </div>
    </div>
  );
};

export default Login;
